import { render, staticRenderFns } from "./verify-2.vue?vue&type=template&id=4b07b869&scoped=true"
import script from "./verify-2.vue?vue&type=script&lang=js"
export * from "./verify-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b07b869",
  null
  
)

export default component.exports